module.exports = __webpack_public_path__ + "static/img/home-close.044f651c.png";